import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Icon, Modal } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Paragraph } from "capitalrx-components-2.0/lib/typography";

import { ThemedButton } from "@/App/components";
import styled from "styled-components";

const LargeIcon = styled(Icon)`
  min-height: unset !important;
  max-height: unset !important;
  min-width: unset !important;
  max-width: unset !important;
  width: 32px;
  height: 32px;
`;

interface FindBestPriceMemberMessageModalProps {
  readonly isVisible: boolean;
  readonly customMessages: string[];
  readonly onClose: () => void;
}

export const FindBestPriceMemberMessageModal: FC<FindBestPriceMemberMessageModalProps> = ({ isVisible, customMessages, onClose }) => {
  const { t: translate } = useTranslation();
  return (
    <Modal
      title={translate("FIND_BEST_PRICE.findBestPriceMemberMessageModal.attention")}
      visible={isVisible}
      onClose={onClose}
      footer={
        <Shelf>
          <Shelf.Spacer />
          <ThemedButton onClick={onClose}>{translate("FIND_BEST_PRICE.findBestPriceMemberMessageModal.continueToPricing")}</ThemedButton>
        </Shelf>
      }
    >
      <Stack alignment="center">
        <Shelf alignment="center">
          <LargeIcon name="info-circle" />
        </Shelf>
        {customMessages.map((cm, idx) => (
          <Paragraph key={idx}>{cm}</Paragraph>
        ))}
      </Stack>
    </Modal>
  );
};
